import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { dateBackendDateTimeToBackend } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import OnboardingBlockAnimatedCard from 'modules/expenses/components/cards/AnimatedCards/OnboardingBlockAnimatedCard'

interface DeadlineBlockProps {
  button: JSX.Element
  currentDeadline: string
}

const DeadlineBlock = ({ currentDeadline, button }: DeadlineBlockProps) => {
  return (
    <>
      <Box
        width="full"
        height="full"
        justifyContent="center"
        alignItems="center"
        paddingX="s64"
        paddingY="s48"
        gap="s40"
        textAlign="center"
      >
        <Box flexDirection="column" gap="s8" maxWidth="s400">
          <Box paddingY="s24">
            <OnboardingBlockAnimatedCard />
          </Box>
          <Text weight="medium" size="400" color="grey1000">
            {i18n.t('expenses_v2.cards.blocks.deadline.title')}
          </Text>
          <Text weight="normal" size="300" color="grey800">
            {i18n.t('expenses_v2.cards.blocks.deadline.description', {
              current_deadline: dateBackendDateTimeToBackend(currentDeadline),
            })}
          </Text>
        </Box>
        <Box flexDirection="column" gap="s32">
          {button}
        </Box>
      </Box>
    </>
  )
}

export default DeadlineBlock
